import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { loginUser, selectUser } from '../features/users/loginSlice';
import signInPicture from '../images/sara_right.png';
import Background from '../images/bg-1.png';
import LogoA from '../images/logo_txt_blanc.png';
import { EnvelopeIcon, KeyIcon } from '@heroicons/react/24/solid';
import { REMOTE_PRODUCT_SELECTED_KEY } from '../constants';

const Login = () => {
  const user = useSelector(selectUser);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (user.isAuthenticated) {
      if (localStorage.getItem(REMOTE_PRODUCT_SELECTED_KEY)) history.push('/account')
      else history.push('/visibility')
    };
  }, [user, history]);

  const handleLogin = (e) => {
    e.preventDefault();
    const { email, password } = e.target;

    Object.userEmail = email.value
    dispatch(loginUser({ email: email.value, password: password.value }));
  };

  return (
    <div className="min-h-screen bg-blue-700 flex items-center">
      <img src={Background} className="fixed z-0 w-full h-full object-cover" alt="Background" />
      <div className="md:ml-20 w-full md:max-w-lg z-10">
        <div className="bg-general-blue text-white shadow rounded-3xl p-10 max-w-lg mx-auto md:max-w-2xl w-full">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="my-6 font-medium text-center text-3xl tracking-wider text-white">Connexion</h2>
          </div>
          <form className="space-y-8" onSubmit={handleLogin} method="POST">
            <div className="space-y-3 isolate rounded-md shadow-sm">
              <div className="bg-white w-full border-gray-300 rounded-full overflow-clip flex items-center text-gray-500 mt-1 px-4 py-3 border shadow-sm">
                <input type="email" name="email" id="email" className="flex-1" placeholder="Adresse-email" required />
                <div className="flex-shrink">
                  <EnvelopeIcon className="w-4 h-4 text-gray-500" />
                </div>
              </div>
              <div className="group bg-white w-full border-gray-300 rounded-full overflow-clip flex items-center text-gray-500 mt-1 px-4 py-3 border shadow-sm">
                <input
                  type="password"
                  name="password"
                  id="password"
                  className="flex-1"
                  placeholder="Mot de passe"
                  required
                />
                <div className="flex-shrink">
                  <KeyIcon className="w-4 h-4 text-gray-500" />
                </div>
              </div>
            </div>

            {user.loginError && <p className="text-sm text-red-500">Username ou mot de passe inccorect !</p>}

            <div>
              <button
                type="submit"
                disabled={user.loading}
                className="mt-10 w-full flex justify-center py-3 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 transition-colors"
              >
                {user.loading ? 'Connexion...' : 'Se connecter'}
              </button>
            </div>

            <div className="mx-auto">
              <div className="text-sm">
                <Link to="/recovery-password" className="font-medium text-xs underline text-white hover:text-teal-500 transition-colors">
                  Mot de passe oublié?
                </Link>
              </div>
            </div>

            <div className="mx-auto my-20">
              <div className="text-sm flex gap-2 items-center justify-center">
                Vous n'avez pas encore de compte?
                <Link to="/signup" className="font-medium text-xs underline text-white hover:text-teal-500 transition-colors">
                  Inscrivez vous
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
      <img src={signInPicture} alt="Sara" className="h-80 transform -translate-x-28 hidden md:block " />
      <div className="max-w-sm hidden lg:block z-50 mx-auto text-center space-y-4">
        <h1 className="text-2xl text-white tracking-wider">Bienvenue sur</h1>
        <img src={LogoA} className="w-64 mx-auto" alt="Background" />
        <p className="text-sm text-white tracking-wider">Connectez-vous à sur notre plateforme Azatys</p>
      </div>
    </div>
  );
};

export default Login;
